import { ICustomerVasInitialState } from "../../../types/master/customerVasInterface";
import { CustomerVasActionTypes, CustomerVasActions } from "../../actionTypes/master/customerVasActionTypes";

const initialState: ICustomerVasInitialState = {
  customerVasList: [],
  customerVasListPageCount: 0,
  customerVasData: {
    id: 0,
    vas_type_id: 0,
    rate_basis_id: 0,
    vas_rate: "",
    min_amount: "",
    customer_id: 0,
    is_active: false,
    vas_type_data: null,
    rate_basis_data: null,
    customer: null,
  },
};

export default function customerVasReducer(
  state = initialState,
  action: CustomerVasActionTypes
): ICustomerVasInitialState {
  switch (action.type) {
    case CustomerVasActions.SET_CUSTOMER_VAS_LIST:
      return {
        ...state,
        customerVasList: action.payload,
      };

    case CustomerVasActions.SET_CUSTOMER_VAS_LIST_PAGE_COUNT:
      return {
        ...state,
        customerVasListPageCount: action.payload,
      };

    case CustomerVasActions.SET_CUSTOMER_VAS_DATA_BY_ID:
      return {
        ...state,
        customerVasData: action.payload,
      };

    default:
      return state;
  }
}
